import { ICreateSubcategoryContext } from './createSubcategoryContext';

export enum CreateSubcategoryActionTypes {
	SET_FILE_ID = 'SET_FILE_ID',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	SET_FETCHED_CATEGORIES = 'SET_FETCHED_CATEGORIES',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	CHANGE_NAME_OF_SUBCATEGORY = 'CHANGE_NAME_OF_SUBCATEGORY',
	TOGGLE_HAS_SCHEDULE_PRIORITY = 'TOGGLE_HAS_SCHEDULE_PRIORITY',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_FETCHED_TRANSLATIONS = 'SET_FETCHED_TRANSLATIONS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetFileId {
	type: CreateSubcategoryActionTypes.SET_FILE_ID;
	payload: {
		fileId: ICreateSubcategoryContext['fileId'];
	};
}

interface ISetFetchedCustomers {
	type: CreateSubcategoryActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: ICreateSubcategoryContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: CreateSubcategoryActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: ICreateSubcategoryContext['IDSelectedCustomer'];
	};
}

interface ISetFetchedRestaurants {
	type: CreateSubcategoryActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: ICreateSubcategoryContext['fetchedRestaurants'];
	};
}

interface ISetIDsRestaurant {
	type: CreateSubcategoryActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: ICreateSubcategoryContext['IDsSelectedRestaurant'];
	};
}

interface ISetFetchedCategories {
	type: CreateSubcategoryActionTypes.SET_FETCHED_CATEGORIES;
	payload: {
		fetchedCategories: ICreateSubcategoryContext['fetchedCategories'];
	};
}

interface ISetIDCategory {
	type: CreateSubcategoryActionTypes.SET_ID_CATEGORY;
	payload: {
		IDSelectedCategory: ICreateSubcategoryContext['IDSelectedCategory'];
	};
}

interface IChangeNameOfSubcategory {
	type: CreateSubcategoryActionTypes.CHANGE_NAME_OF_SUBCATEGORY;
	payload: {
		nameOfSubcategory: ICreateSubcategoryContext['nameOfSubcategory'];
	};
}

interface IToggleHasSchedulePriority {
	type: CreateSubcategoryActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY;
}

interface IChangeActivationSchedule {
	type: CreateSubcategoryActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: ICreateSubcategoryContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: CreateSubcategoryActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: ICreateSubcategoryContext['deactivationSchedule'];
	};
}

interface ISetFetchedTranslation {
	type: CreateSubcategoryActionTypes.SET_FETCHED_TRANSLATIONS;
	payload: {
		translations: ICreateSubcategoryContext['translations'];
		defaultCustomerLanguage: ICreateSubcategoryContext['defaultCustomerLanguage'];
	};
}

interface ISetTranslationTab {
	type: CreateSubcategoryActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: ICreateSubcategoryContext['selectedTranslationTab'];
	};
}

interface IChangeTranslation {
	type: CreateSubcategoryActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: ICreateSubcategoryContext['translations'];
	};
}

interface ISetDataForSubmit {
	type: CreateSubcategoryActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateSubcategoryContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateSubcategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ICreateSubcategoryContext['typeOfModalWindow'];
	};
}

interface IResetSelectedControls {
	type: CreateSubcategoryActionTypes.RESET_FIELDS;
}

export type TCreateSubcategoryAction =
	| ISetFileId
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDsRestaurant
	| ISetFetchedCategories
	| ISetIDCategory
	| IResetSelectedControls
	| IChangeNameOfSubcategory
	| IToggleHasSchedulePriority
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetFetchedTranslation
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
